module.exports = __webpack_public_path__ + "img/c1c79b489a61f3c3580371406cef161c.png";